// 性别类型
export const genderTypeList = [
  {
    title: "Male",
    value: "Male",
  },
  {
    title: "Female",
    value: "Female",
  },
];

// 交易类型 (Quotation (V) 中使用)
export const transactionTypeList = [
  {
    title: "Payment",
    value: 1,
  },
  {
    title: "Refund",
    value: 2,
  },
];

// 营销邮件推送方式
export const marketingEmailPushTypeList = [
  {
    title: "Immediate Send",
    value: 1,
  },
  {
    title: "Scheduled Send",
    value: 2,
  },
];
